import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "../../index.css";
import { Link } from "react-router-dom";
import ListInvitationDetail from "./ListInvitationDetail";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import CardReview from "@/Components/MyPage/CardReview";
dayjs.locale("ko");

const S3_URL = import.meta.env.VITE_S3_URL;

function ListReview({ dataReview, setActiveTab }) {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dataReview]);

  const handleOpenModal = (campaign) => {
    setSelectedCampaign(campaign);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCampaign(null);
  };
  const fetchDataReservation = async (campaign_id) => {
    try {
      const token = getWithExpiry("token");
      const response = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/user/reservation/list?campaign_id=${campaign_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      const json = await response.json();

      if (json.meta.code === 200) {
        setReservationData((prev) => ({
          ...prev,
          [campaign_id]: json.data, // Simpan data per campaign_id
        }));
      } else {
        throw new Error(
          json.meta?.message || "Failed to fetch reservation data"
        );
      }
    } catch (error) {
      console.error("Failed to fetch calendar data:", error);
    }
  };

  return (
    <>
      <div className="flex mt-5 pb-10">
        <div className="gap-6 w-full">
          {dataReview.length > 0 ? (
            dataReview.map((item, index) => {
              const data = item.campaigns || item;

              // Famtour campaigns grouping
              if(Array.isArray(data) && data.length > 0) {
                return <div className="border border-1 border-[#C9C9C9] rounded-md">
                  <div className="flex justify-between mx-3 mt-2">
                    <a href={`/detailFamtour/${data[0].fam_tour_id}`} className="font-bold text-[12px] text-[#46B6D0]">{data?.[0].fam_tour_title}</a>
                  </div>
                  {
                    data.map((famtour, i) => {
                      const rewardText = famtour.reward
                        .replace(/<[^>]*>?/g, "")
                        .replace(/&nbsp;/g, " ");

                      return <CardReview key={i} item={famtour} rewardText={rewardText} handleOpenModal={handleOpenModal}/>
                    })
                  }
                </div>
              }

              const rewardText = item.reward
                .replace(/<[^>]*>?/g, "")
                .replace(/&nbsp;/g, " ");
              return (
                <CardReview key={index} item={item} rewardText={rewardText} handleOpenModal={handleOpenModal}/>
              );
            })
          ) : (
            <div className="text-[12px] text-center text-[#999999] items-center justify-center py-10">
              <p className="">신청한 캠페인이 없습니다.</p>
              <p className="mt-1">다양한 캠페인에 신청해보세요:)</p>
              <div>
                <Link to={"/"}>
                  <button className="border text-[12px] bg-[#E8EAF9] mt-3 text-[#0F1E6C] rounded-full px-3 py-2">
                    <p>캠페인 신청하러가기</p>
                  </button>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>

      {showModal && selectedCampaign && (
        <ListInvitationDetail
          open={showModal}
          el={selectedCampaign}
          setShowModals={handleCloseModal}
          setActiveTab={setActiveTab}
        />
      )}
    </>
  );
}

export default ListReview;